import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";

export default function ProtectedRoute({ children, requireAdmin = false }) {
  const { user, loading } = useAuth();
  const location = useLocation();
  if (loading) {
    return <div className="min-h-[60vh] flex items-center justify-center text-overline text-zinc-500">Loading…</div>;
  }
  if (!user) {
    // Remember where the user was trying to go so we can return them there after login.
    const from = location.pathname + location.search + location.hash;
    return <Navigate to="/login" replace state={{ from }} />;
  }
  if (requireAdmin && user.role !== "admin") return <Navigate to="/" replace />;
  return children;
}
